import { Skeleton } from "react-vant";

export function ProductListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="product-card-h skeleton">
          <Skeleton avatar avatarSize={90} avatarShape="square" loading row={3} />
        </div>
      ))}
    </div>
  );
}

/**
 * Compact horizontal-scroll skeleton — matches ProductCard variant="compact"
 * dimensions to keep the lane height stable during the first paint.
 */
export function CompactCardLaneSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="scroll-lane">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="product-card-compact"
          style={{ pointerEvents: "none" }}
        >
          <Skeleton avatar avatarSize="100%" avatarShape="square" loading row={2} />
        </div>
      ))}
    </div>
  );
}

/**
 * Brand hero skeleton — placeholder for BrandPage's circular-logo hero card
 * while BrandDetail resolves.
 */
export function BrandHeroSkeleton() {
  return (
    <div
      style={{
        padding: "36px 16px 28px",
        background:
          "linear-gradient(135deg, #4a1c2a 0%, #6d2839 55%, #8a3d50 100%)",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: 84,
          height: 84,
          margin: "0 auto",
          borderRadius: 14,
          background: "rgba(255,255,255,0.2)",
        }}
      />
      <div
        style={{
          width: 80,
          height: 10,
          margin: "16px auto 8px",
          borderRadius: 4,
          background: "rgba(255,255,255,0.18)",
        }}
      />
      <div
        style={{
          width: 140,
          height: 18,
          margin: "0 auto",
          borderRadius: 4,
          background: "rgba(255,255,255,0.25)",
        }}
      />
    </div>
  );
}

/**
 * Detail page hero + content skeleton.
 */
export function DetailSkeleton() {
  return (
    <div>
      <div
        style={{
          width: "100%",
          height: 340,
          background: "#ececec",
        }}
      />
      <div className="card">
        <Skeleton row={3} loading title />
      </div>
      <div className="card">
        <Skeleton row={4} loading />
      </div>
      <div className="card">
        <Skeleton row={3} loading />
      </div>
    </div>
  );
}
